import '../../common/polyfills'
import '../common/polyfills/requestIdleCallback'
import 'intersection-observer'
import React from 'react'
import { hydrate } from 'react-dom'
import { Router } from 'react-router-dom'
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  // eslint-disable-next-line node/no-missing-import
} from '@apollo/client'

import { App } from './listings-client'
import { customHistory } from './util/routingHelper/routerHistory'

// Do not delete the below code. Used for testing accessibility during development

// if (process.env.NODE_ENV !== 'production') {
//   const axe = require('react-axe');
//   axe(React, ReactDOM, 1000);
// }

if (process.env.NODE_ENV !== 'production') {
  const { whyDidYouUpdate } = require('why-did-you-update')
  whyDidYouUpdate(React, {
    include: [/^listings/i],
  })
}

const client = new ApolloClient({
  uri: '/pws/v0/pcln-graph/',
  cache: new InMemoryCache(),
})

hydrate(
  <ApolloProvider client={client}>
    <Router history={customHistory}>
      <App airSearchPromise={window.__AIR_SEARCH_PROMISE__} />
    </Router>
  </ApolloProvider>,
  document.getElementById('root')
)
